module.exports = __webpack_public_path__ + "img/error-illustration.ef971d31.svg";